<template>
  <div id="app" ref="app">
    <!-- 全局加载方法 -->
    <!-- <van-overlay
      z-index="999"
      :show="showLoading"
      class-name="page-load-box"
    >
      <div class="loadbox">
        <van-loading
          size="50px"
          color="#1989fa"
          text-color="#1989fa"
          vertical
        >加载中...</van-loading>
      </div>
    </van-overlay> -->
    <router-view :key="$route.fullPath" v-if="showCont"></router-view>
    <!-- 2.2.4版本 -->
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { Loading } from 'element-ui';
import {
  setNavStatus,
  getLoginStatus,
  getUserInfo,
  opneLoginPane,
  setUser,
} from "@/utils/app";
var loadingInstance='';
export default {
  name: "App",
  data () {
    return {
      showCont:false,
      type:0,
      keyId:0,
    }
  },
  computed: {
    ...mapState(["loading","showVideo"]),
  },
  created () {
    
    setTimeout(() => {
      // this.showLoading=false
      this.showCont =true
    }, 500);
    loadingInstance = Loading.service({
        lock: false,
        spinner: '',
        background: 'rgba(255, 255, 255, 1)'
    });
    //定义app返回方法
    window.setUserInfo = this.setUserInfo;
    window.setLocation = this.setLocation;
    window.setIsLogin = this.setIsLogin; // 获取登录状态
    window.loginOut = this.loginOut;
  },
  mounted () {
    
    if (this.equipmentType() == "iOS") {
      this.type = 0;
    } else if (this.equipmentType() == "Android") {
      this.type = 1;
    } else {
      this.type = 3;
    }
    this.handleWindow(this.type)
    window.addEventListener('resize',this.handleWindow,true)
    setTimeout(() => {
      this.$store.state.showVideo = true
      loadingInstance.close()
    }, 2000);
    
    // 判断是否在微信打开
    var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      this.backAll()
      this.setInWx(true);
      
    } else {
      this.setInWx(false);
    }
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("zsweb") > -1 && u.indexOf("android") > -1; //android终端
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isIOS) {
      //获取登录状态
      this.setInIOS(true);
      getLoginStatus();
    } else if (isAndroid) {
      this.setInAndroid(true);
      getLoginStatus();
    } else {
      this.setInIOS(false);
      this.setInAndroid(false);
    }
    
  },
  // watch: { // 监听路由是否变为链接分享页
  //   $route(news){
  //     console.log(news.path);
  //     console.log(this.type);
  //     if (news.path=='/preview') {
  //       console.log('2333');
  //       this.$refs.app.style.maxWidth=1200+'px'
  //     }
  //   }
  // },
  methods: {
    backAll () {
      var state = {
        title: "title",
        url: "#"
      };
      window.history.pushState(state, "title", "#");
      var that = this
      setTimeout(function () { // 监听返回
        window.addEventListener("popstate", function(e) {
        that.$router.go(0)
        }, false);
      },1000);
    },
    equipmentType () {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        return "Android";
      } else if (isiOS) {
        return "iOS";
      } else {
        return "noMobileDevices";
      }
    },
    handleWindow () {
      this.$nextTick(()=>{
        if (this.type ==3 ) {
            this.$refs.app.style.maxWidth=375+'px'
        }else{
          this.$refs.app.style.maxWidth=100+'%'
        }
        let width = document.getElementsByTagName('html')[0]
        let body = document.body
        let appWidth = this.$refs.app.offsetWidth
        width.style.fontSize = appWidth/10 + 'px'
        if (this.type !==3 ) {
          body.style.backgroundColor = '#fff'
        }
      })
    },

    ...mapMutations(["setInWx", "setInIOS", "setInAndroid"]),
    setPayResult: function (data) {
      console.log(data, "setPayResult");
      setTimeout(() => {
        console.log(data, "setPayResult");
      }, 5000);
    },
    setUserInfo: function (data) {
      setUser(data);
      window.sessionStorage.setItem(
        "userinfo",
        JSON.stringify(data)
      );
    },
    setLocation: function (data) {
      setLocalStorage({
        iosloca: data,
      });
    },
    setIsLogin: function (data) {
      if (data == 1) {
        //已登录
        return getUserInfo();
      } else {
        //未登录
        // opneLoginPane();
        // window.localStorage.clear();
      }
    },
    loginOut: function () {
      window.localStorage.clear();
    },
  },
};
</script>

<style>
@import './components/setFont/font.less';
* {
  margin: 0;
  padding: 0;
  list-style: none;
}
/* html{
  min-height:100%
} */
html,
body {
  height: 100%;
  /* min-height: 100%; */
  font-family: SourceHan !important;
  background-color: #f0f2f5;
}
#app {
  /* height: 100%; */
  min-height: 100%;
  /* max-width: 375PX; */
  margin: auto;
  background-color: #fff;
}
.van-dialog,.van-toast{
  z-index: 10002 !important;
}
.page-load-box{
  height: 100%;
  background-color: #fff;
}
</style>
